import NotFooterLayout from "layouts/NotFooterLayout";
import ManageCreditList from "components/ManageCredit/ManageCreditList";

function ManageCreditPage() {
  return (
    <NotFooterLayout namePage="จัดการเครดิตและพอยต์" >
      <div className="layout-content">
        <ManageCreditList />
      </div>
    </NotFooterLayout>
  );
}

export default ManageCreditPage;
